import { render, staticRenderFns } from "./UserAssignPersonForm.vue?vue&type=template&id=75aad528"
import script from "./UserAssignPersonForm.vue?vue&type=script&lang=js"
export * from "./UserAssignPersonForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports